<template>
  <div class="vem-root" :class="{ standalone: !embedded }">
    <nav class="crumbs">
      <span class="crumb-sec">{{ t('app.section') }}</span>
      <span class="crumb-sep">›</span>
      <button type="button" class="crumb-link" @click="close">{{ t('app.title') }}</button>
      <template v-if="editing">
        <span class="crumb-sep">›</span>
        <span class="crumb-cur">{{ editingName }}</span>
      </template>
    </nav>
    <p v-if="catalog.error" class="notice err">{{ catalog.error }}</p>
    <Transition name="vem-view" mode="out-in">
      <DefList v-if="!editing" :key="'list-' + reloadTick" @open="open" />
      <DefEditor v-else :key="'ed-' + (editingKey || 'new') + '-' + reloadTick" :def-id="editingId"
                 @back="close" @saved="onSaved" @title="editingTitle = $event" />
    </Transition>
    <ConfigBar v-if="!embedded" @changed="reload" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import DefList from '@vem/components/DefList.vue';
import DefEditor from '@vem/components/DefEditor.vue';
import ConfigBar from '@vem/components/ConfigBar.vue';
import { t } from '@vem/i18n.js';
import { catalog, loadCatalog, resetCatalog } from '@vem/catalog.js';

defineProps({ embedded: { type: Boolean, default: false } });

const editing = ref(false);
const editingId = ref(null);
// Clave de montaje del editor: no cambia al guardar una definición nueva (no se re-monta).
const editingKey = ref(null);
const editingTitle = ref('');
// Una definición existente aún sin cargar no se llama «Nueva materialización»: la miga espera a su nombre.
const editingName = computed(() => editingTitle.value || (editingId.value ? '' : t('list.new').replace(/^\+\s*/, '')));
const reloadTick = ref(0);

function open(id) {
  editingId.value = id;
  editingKey.value = id;
  editingTitle.value = '';
  editing.value = true;
}

function close() {
  editing.value = false;
  editingId.value = null;
}

function onSaved(id) {
  editingId.value = id;
}

function reload() {
  resetCatalog();
  loadCatalog();
  reloadTick.value++;
}

onMounted(() => loadCatalog());
</script>
